import { Button, Text } from "@shopify/polaris";
import React, { useRef, useState } from "react";
import Xero from "../../../../img/integrations/xero_icon.png";
import Google from "../../../../img/logos/google-logo.svg";
import BannerCustom from "components/Banners/BannerCustom";
import { getResponseErrorMessage } from "../../../../utils/errors";
import { stashReturnUrlFromCurrentLoginPage } from "utils/authReturnUrl";
import { resolveSocialStartUrl, getSocialFetchCredentials } from "../../shared/utils/socialLoginComplete";

const LoginButtons = () => {
  const [error, setError] = useState("");
  const startingRef = useRef(false);

  const startSocialLogin = async (endpoint) => {
    if (startingRef.current) return;
    startingRef.current = true;
    setError("");
    stashReturnUrlFromCurrentLoginPage();
    const backendUrl = resolveSocialStartUrl(endpoint);

    try {
      const res = await fetch(backendUrl, {
        method: "GET",
        mode: "cors",
        credentials: getSocialFetchCredentials(backendUrl),
      });
      if (!res.ok) {
        throw new Error(await getResponseErrorMessage(res));
      }

      const data = await res.json();
      const redirectURL = resolveSocialStartUrl(data.redict_url);
      if (!redirectURL) {
        startingRef.current = false;
        setError("No redirect URL in response");
        return;
      }
      window.location.href = redirectURL;
    } catch (err) {
      startingRef.current = false;
      setError(err?.message || "Error");
    }
  };

  return (
    <div style={{ marginTop: 40 }}>
      {error ? (
        <div style={{ marginBottom: 16 }}>
          <BannerCustom
            status="critical"
            message={error}
            onDismiss={() => setError("")}
          />
        </div>
      ) : null}
      <div>
        <div style={{ padding: 0 }}>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "50%",
                height: 2,
                backgroundColor: "rgb(213, 220, 224)",
                marginRight: 20,
              }}
            ></div>
            <Text variant="headingMd" as="h2">
              OR
            </Text>
            <div
              style={{
                width: "50%",
                height: 2,
                backgroundColor: "rgb(213, 220, 224)",
                marginLeft: 20,
              }}
            ></div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: 20,
            }}
          >
            <Button
              fullWidth
              variant="secondary"
              onClick={() => startSocialLogin("/api/1/login/xero/")}
            >
              <img
                src={Xero}
                alt="Xero"
                style={{
                  width: 35,
                  height: 35,
                }}
              />
              Sign in with Xero
            </Button>

            <Button
              fullWidth
              variant="secondary"
              onClick={() => startSocialLogin("/api/1/login/google/")}
            >
              <img
                src={Google}
                alt="Google"
                style={{
                  width: "auto",
                  height: 12,
                  marginRight: 5,
                }}
              />
              Sign in with Google
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginButtons;
